import { makeAutoObservable } from "mobx";

class ChatManager {
  // Singleton instance
  static instance = null;

  constructor() {
    if (ChatManager.instance) {
      return ChatManager.instance;
    }
    ChatManager.instance = this;

    /* SCROLL */
    this.selectedReplyToId = null;
    this.flatListRef = null;
    this.messageIndexes = {};
    this.isDragging = false;

    /* LOADING */
    this.updatingMessagesLoading = true;

    /* ALERTS */
    this.showingPermissionsAlert = false;
    this.showingStorageAlert = false;

    makeAutoObservable(this);
  }
  // Singleton access method
  static getInstance() {
    if (!ChatManager.instance) {
      ChatManager.instance = new ChatManager();
    }
    return ChatManager.instance;
  }

  setProperty(propertyName, value) {
    if (propertyName in this) {
      this[propertyName] = value;
    } else {
      console.warn(`Property "${propertyName}" does not exist on ChatManager.`);
    }
  }

  /* SCROLL */
  addMessageIndex(message, index) {
    // Ensure messageIndexes exists
    if (!this.messageIndexes) {
      this.messageIndexes = {};
    }
    this.messageIndexes[message.id.toString()] = index;
  }

  scrollToBottom(animated = true) {
    if (this.flatListRef) {
      this.flatListRef.scrollToOffset({ offset: 0, animated });
      // this.flatListRef.scrollToEnd({ animated });
    }
  }

  scrollToOffset(offset, animated = true) {
    if (this.flatListRef) {
      this.flatListRef.scrollToOffset({ offset, animated });
    }
  }

  scrollToKey(messageId, animated = false) {
    const index = this.messageIndexes && this.messageIndexes[messageId];
    if (typeof index !== "undefined" && this.flatListRef) {
      console.log("scrolling to index ", index);
      this.flatListRef.scrollToIndex({
        index,
        animated,
        viewPosition: 0.5,
      });
    } else {
      console.warn(
        `Message with id ${messageId} not found or flatListRef not set.`
      );
    }
  }
}

export default ChatManager;
